import React, { useEffect, useState } from "react";
import DynamicForm from "../../../customformComponent/customForm/DynamicForm";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTable from "../../../customComponents/CustomTable";
import {
  TABLE_DATA,
  TABLE_HEADERS,
  keyMapping,
} from "../../../../constants/Accessories";
import axiosInstance from "../../../services/api/API";
import Loader from "../../../customComponents/CustomLoader";

const AddAccessories = ({ isdistributor ,logisticID,BUSINESSPARTNERID,LOGISTICID}) => {
  console.log("businesspartnerid",BUSINESSPARTNERID);
  
  const [formData, setFormData] = useState({});
  const [variantOptions, setVariantOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(true)
  const [productRequirementOptions, setProductRequirementOptions] = useState(
    []
  );
  const token = localStorage.getItem("authToken");
  const [sparePartOptions, setSparePartOptions] = useState([]);
  const [PartOptions, setPartOptions] = useState([]);
  const [warrantyOptions, setWarrantyOptions] = useState([]);
  const [sparePartDetails, setSparePartDetails] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  // const logistic_id = localStorage.getItem("logistic_id");
  const location = useLocation();
  const business_partner_id=location?.state?.data?.business_partner_id
  const logistic_id=location?.state?.data?.logistic_id 
  const [logisticstockid, setLogisticStockId] = useState(0);
  const [iseditmode, setisEditMode] = useState(false);

  console.log("location>>",location);
  
  
  const editlogisticid=location?.state?.data?.logistic_id
  const handleFormSubmit = async (data) => {
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      console.log("field>>", field);
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors", validationErrors);
      return;
    }

    

    try {
      setLoading(true)
      const token = localStorage.getItem("authToken");
      
      if (iseditmode) {
        const response = await axiosInstance.patch(
          `/logisticsstock/update/${logisticstockid}`,
          {
            stock_type: "A" || null,
            business_partner_id:  BUSINESSPARTNERID || business_partner_id ,
            logistic_id:  editlogisticid || logisticID || LOGISTICID,
            product_id: data?.productname || null,
            variant_id: data?.variant || null,
            vehicle_id: 1 || null,
            purchase_price:data?.purchaseprice,
            selling_price:data?.sellingprice,
            serial_no: data?.serialno,
            item_id: data?.accessories || null,
            part_category_id: data?.partcategory || null,
            product_requirement_id: data?.productrequirement || null,
            part_type_id: 1 || null,
            brandname: data?.brandname || null,
            remark: formData?.remark || "none",
            warranty_id:formData?.warranty,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        const response = await axiosInstance.post(
          `/logisticsstock/create`,
          {
            stock_type: "A" || null,
            business_partner_id: BUSINESSPARTNERID || business_partner_id,
            logistic_id: logistic_id!=="undefined"?logistic_id ||LOGISTICID : editlogisticid || LOGISTICID,
            product_id: data?.productname || null,
            variant_id: data?.variant || null,
            vehicle_id: 1 || null,
            serial_no: data?.serialno,
            item_id: data?.accessories || null,
         purchase_price:data?.purchaseprice,
         selling_price:data?.sellingprice,
            part_category_id: data?.partcategory || null,
            product_requirement_id: data?.productrequirement || null,
            part_type_id: 1 || null,
            brandname: data?.brandname || null,
            remark: formData?.remark || "none",
            warranty_id:formData?.warranty,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      setFormData({});
      fetchLogisticData();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
    finally{
      setLoading(false)
    }
  };

  const fetchproductRequirementOptions = async () => {
    try {
      const partResponse = await axiosInstance.post(
        "/logisticsstock/ddlproductrequirement",
        { business_partner_id: 1 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const productreqOptions = partResponse.data.data?.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));
      setProductRequirementOptions(productreqOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchWarrantyeOptions = async() => {
    try {
    const partResponse = await axiosInstance.post('/warranty/ddlwarranty', { business_partner_id: BUSINESSPARTNERID }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const warrantyOptions = partResponse.data?.data?.data?.map(product => ({
      label:product.NAME,
      value: product.ID,
    }));
    console.log("warrantyOptions",warrantyOptions);
    
    setWarrantyOptions(warrantyOptions);
  } catch (error) {
    console.log(error); 
    
  }
  
  }
  const fetchPartCategoryOptions = async () => {
    try {
      const partResponse = await axiosInstance.post(
        "/partcategory/ddlpartcategory",
        { business_partner_id: 1 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const partOptions = partResponse.data.data.data?.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));
      setPartOptions(partOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSparePartOptions = async () => {
    try {
      const sparepartResponse = await axiosInstance.post(
        "/item/ddlitem",
        {
          itemtype_id: 2, //1 for Spare-Parts//2 for accessory
          business_partner_id: BUSINESSPARTNERID,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const spareOptions = sparepartResponse.data.data.data?.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));
      setSparePartOptions(spareOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchProductOptions = async () => {
    try {
      const productResponse = await axiosInstance.post(
        "/product/ddlproduct",
        { business_partner_id: BUSINESSPARTNERID|| business_partner_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const productOptions = productResponse.data.data.data?.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));
      setProductOptions(productOptions);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchProductOptions();
    fetchSparePartOptions();
    fetchPartCategoryOptions();
    fetchproductRequirementOptions();
    fetchWarrantyeOptions();
  }, []);
  // useEffect(() => {
  //   if (formData.accessories) {
  //     console.log("formData", formData);
  //     const fetchSparePartDetails = async () => {
  //       try {
  //         const token = localStorage.getItem("authToken");

  //         const response = await axiosInstance.post(
  //           "/item/ddlitembase",
  //           {
  //             itemtype_id: 2, //1 for Spare-Parts//2 for accessory
  //             business_partner_id: 1,
  //             item_id: formData?.accessories,
  //           },
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  //         const sparepartdetails = response?.data?.data?.data[0];
  //         setSparePartDetails(sparepartdetails);
  //         console.log("sparePartDetails", sparepartdetails);

  //         setFormData({
  //           ...formData,
  //           sellingprice: sparepartdetails?.selling_price,
  //           purchaseprice: sparepartdetails?.purchase_price,
  //           warranty: sparepartdetails?.warranty_name,
  //         });
  //       } catch (error) {
  //         console.error("Error fetching variant options:", error);
  //       }
  //     };

  //     fetchSparePartDetails();
  //   }
  // }, [formData.accessories]);
  useEffect(() => {
    if (formData.productname) {
      console.log("formData", formData);
      const fetchVariantOptions = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axiosInstance.post(
            "/variant/ddlvariant",
            {
              business_partner_id: BUSINESSPARTNERID,
              product_id: formData.productname,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const variantOptions = response.data.data.data?.map((variant) => ({
            label: variant.NAME,
            value: variant.ID,
          }));

          setVariantOptions(variantOptions);
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchVariantOptions();
    }
  }, [formData.productname]);

  useEffect(() => {
    if (formData?.variant) {
      const fetchVariantBasedDetails = async () => {
        try {
          const response = await axiosInstance.post(
            "/variant/ddlvariantbasedetails",
            {
              //business_partner_id: 1,
              variant_id: formData.variant,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const variantwisedata = response?.data?.data?.data[0];
          console.log("variantwisedata", variantwisedata);

          setFormData({
            ...formData,

            fueltype: variantwisedata?.fuel_type_name,
            subproduct: variantwisedata?.subproduct_name,
            make: variantwisedata?.make_name,
            model: variantwisedata?.model_name,
            exshowroomprice: variantwisedata?.exshowroom_price,
            color: variantwisedata?.color_name,
            price: variantwisedata?.exshowroom_price,
          });
        } catch (error) {
          console.error("Error fetching variant options:", error);
        }
      };

      fetchVariantBasedDetails();
    }
  }, [formData?.variant]);
  const CustomerInputs = [
    {
      name: "productname",
      label: "Product",
      type: "dropdown",
      options: productOptions,
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "variant",
      label: "Variant",
      type: "dropdown",
      options: variantOptions,
      validation: { required: true },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "subproduct",
      label: "Sub Product",
      type: "text",
      disabled: true,

      gridClass: "col-lg-4",
    },
    {
      name: "make",
      label: "Make",
      type: "text",
      disabled: true,

      gridClass: "col-lg-4",
    },
    {
      name: "model",
      label: "Model",
      type: "text",

      disabled: true,
      gridClass: "col-lg-4",
    },
    {
      name: "fueltype",
      label: "Fuel Type",
      type: "text",
      disabled: true,

      gridClass: "col-lg-4",
    },
    {
      name: "color",
      label: "Color",
      type: "text",
      disabled: true,

      gridClass: "col-lg-4",
    },
    {
      name: "serialno",
      label: "Serial No.",
      type: "text",
      placeholder:"Enter Serial No.",
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
    {
      name: "accessories",
      label: "Accessories",
      type: "dropdown",
      options: sparePartOptions,
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "vehicle_id",
    //   label: "Vehicle ID.",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    // },

    {
      name: "purchaseprice",
      label: "Purchase Price",
      type: "text",
      placeholder:"Enter Purchase Price",
      validation: { 
        required: true,
        pattern: /^[0-9]+(\.[0-9]{1,2})?$/, 
        message: "Please enter a valid purchase price with up to 2 decimal points*"
      },
     // disabled: true,
      gridClass: "col-lg-4",
    },
    {
      name: "sellingprice",
      label: "Selling Price",
      type: "text",
      placeholder:"Enter Selling Price",
      validation: { 
        required: true,
        pattern: /^[0-9]+(\.[0-9]{1,2})?$/, 
        message: "Please enter a valid selling price with up to 2 decimal points*"
      },
     // disabled: true,
      gridClass: "col-lg-4",
    },

    {
      name: "partcategory",
      label: "Part Category",
      type: "dropdown",
      options: PartOptions,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "warranty",
      label: "Warranty",
      type: "dropdown",
      options:warrantyOptions,
      required: true,

      gridClass: "col-lg-4",
    },
    {
      name: "brandname",
      label: "Brand Name",
      type: "text",
      required: false,
      isVisible: false,
      gridClass: "col-lg-4",
    },

    {
      name: "productrequirement",
      label: "Product Requirement",
      type: "dropdown",
      options: productRequirementOptions,
      validation: { required: true },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder:"Enter Remark",
      required: true,
      validation:{required:true},
      gridClass: "col-lg-4",
    },
  ];
  useEffect(() => {
    fetchLogisticData();
  }, []);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchLogisticData(newPage);
  };

  const fetchLogisticData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        "/logisticsstock/list",
        {
          logistic_id:  logisticID ||LOGISTICID,
          stock_type: "A",
          orderBy: "logistic_id desc",
          page,
          pageSize,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setTableData(formattedData);
      // toastSuccess("Product Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching vendor list:", error);
    }
    finally{
      setLoading(false)
    }
  };

  const handleEdit = async (rowData) => {
    setisEditMode(true);

    try {
      const response = await axiosInstance.get(
        `/logisticsstock/edit/${rowData.logistic_stock_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const vehicleData = response.data.data;
        setLogisticStockId(vehicleData?.logistic_stock_id);
        console.log("vehicleData>>", vehicleData);

        const transformedData = {
          productname: vehicleData.product_id,
          variant: vehicleData.variant_id,
          subproduct: vehicleData?.subproduct_name,
          make: vehicleData.make_name,
          model: vehicleData.model_name,
          fueltype: vehicleData?.fuel_type_name,
          color: vehicleData?.color_name,
          price: vehicleData?.exshowroom_price,
          serialno: vehicleData?.serial_no,
          accessories: vehicleData?.item_id,
          partcategory: vehicleData?.part_category_id,
          purchaseprice: vehicleData?.purchase_price,
          sellingprice:vehicleData?.selling_price,
          productrequirement: vehicleData?.product_requirement_id,
          warranty: vehicleData?.warranty_id,
          brandname: vehicleData?.brandname || null,
          remark: vehicleData?.remark,
        };
        setFormData(transformedData);
        console.log("vehicleformData", formData);
      } else {
        console.error("Failed to fetch vehicle data");
      }
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    }
  };
  return (
    <>
   
      <div>
        <div
          className="d-flex flex-row justify-content-between"
          style={{ marginBottom: "25px" }}
        >
          <div>
            <span className="cust-det-title mt-2 mb-2">Add Accessories</span>
          </div>
       
        </div>
        <div>
        {loading ? ( 
      <Loader />
    ) : (
      <><div>
                <DynamicForm
                  //formConfig={CustomerInputs}
                  formConfig={CustomerInputs.filter((input) => {
                    if (input.name === "brandname") {
                      return isdistributor;
                    }
                    return true;
                  }).map((input) => {
                    if (input.name === "brandname") {
                      return {
                        ...input,
                        isVisible: isdistributor,
                        required: isdistributor
                      };
                    }
                    return input;
                  })}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3 gap-2">

                  <button
                    onClick={() => handleFormSubmit(formData)}
                    className="submit-btn"
                  >
                    {iseditmode ? "Update" : "Submit"}
                  </button>
                </div><div className="tableWrapper">
                  <div className="admin-list-container">
                    <div className="listsearchContainer">
                      <h5>Vehicle Accessories Details</h5>
                    </div>

                  </div>

                  <CustomTable
                    data={tableData}
                    headers={TABLE_HEADERS}
                    keyMapping={keyMapping}
                    itemsPerPage={10}
                    onEdit={handleEdit}
                    onPageChange={handlePageChange}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords} />
                </div></>
     
      )}
       </div>
      </div>
    </>
  );
};

export default AddAccessories;
